import { useHelpers } from '../helpers/useHelpers';

/**
 * Decorador genérico para manejo de errores que elimina la duplicación del patrón try-catch-errorHandler
 * @param fn Función asíncrona que puede lanzar errores
 * @returns Función envuelta con manejo automático de errores
 */
export function withErrorHandling<T extends any[], R>(fn: (...args: T) => Promise<R>): (...args: T) => Promise<R> {
  return async (...args: T) => {
    const { errorHandler } = useHelpers();
    try {
      return await fn(...args);
    } catch (error) {
      errorHandler(error);
      throw error;
    }
  };
}

/**
 * Crea un objeto de servicios con manejo automático de errores
 * @param serviceDefinitions Objeto con las definiciones de los servicios
 * @returns Objeto con los servicios envueltos en manejo de errores
 */
export function createServiceWithErrorHandling<T extends Record<string, (...args: any[]) => Promise<any>>>(serviceDefinitions: T): T {
  const wrappedService = {} as T;

  for (const [key, fn] of Object.entries(serviceDefinitions)) {
    (wrappedService as any)[key] = withErrorHandling(fn);
  }

  return wrappedService;
}
